module.exports = __webpack_public_path__ + "static/media/etiquette.cef85d13.svg";